<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Delete Pyramid Entry</h2>
  </div>

  <mat-dialog-content>
    <div class="dialog-message">
      <p>You are about to delete <strong>{{ data.itemName }}</strong> from the pyramid.</p>
      @if (data.hideDeleteCurrentYear) {
        <p>Click on years to select/deselect them for deletion. This action cannot be undone.</p>
      } @else {
        <p>You can use the buttons below, or click on individual years to select which ones to delete.</p>
      }

      @if (data.allYears && data.allYears.length > 0) {
        <div class="years-info">
          <div class="years-header">
            <strong>This entry exists in {{ data.allYears.length }} {{ data.allYears.length === 1 ? 'year' : 'years' }}:</strong>
            <div class="selection-actions">
              <button mat-button class="select-action-btn" (click)="selectAllYears()">
                <mat-icon>select_all</mat-icon>
                Select All
              </button>
              <button mat-button class="select-action-btn" (click)="deselectAllYears()">
                <mat-icon>deselect</mat-icon>
                Deselect All
              </button>
            </div>
          </div>
          <div class="years-list">
            @for (year of data.allYears; track year) {
              <span class="year-chip"
                    [class.current-year]="!data.hideDeleteCurrentYear && year === data.currentYear"
                    [class.selected]="isYearSelected(year)"
                    (click)="toggleYearSelection(year)">
                <mat-icon class="check-icon">{{ isYearSelected(year) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                {{ year }}
              </span>
            }
          </div>
          @if (selectedYearsCount > 0) {
            <div class="selection-summary">
              <strong>{{ selectedYearsCount }}</strong> {{ selectedYearsCount === 1 ? 'year' : 'years' }} selected for deletion
            </div>
          }
        </div>
      }
    </div>
  </mat-dialog-content>

  <!-- Dialog Actions -->
  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button type="button" class="nrg-error-flat-button back-button" (click)="onCancel()">
      <mat-icon>clear</mat-icon>
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="onDeleteSelectedYears()" [disabled]="!hasSelectedYears">
      <mat-icon>delete</mat-icon>
      Delete Selected ({{ selectedYearsCount }})
    </button>
  </div>
</div>
